/**
 * Grundtypen des Geometriekerns.
 *
 * Es gibt drei Ebenen, und sie werden nie vermischt:
 *
 *   1. Geo      — Grad, WGS84. Nur an der Schnittstelle zur Karte.
 *   2. Grundriss — Meter, lokale Tangentialebene. x nach Osten, y nach Norden.
 *                  Das ist die Projektion, die man im Luftbild sieht.
 *   3. Dachebene — Meter, in der geneigten Flaeche. u laengs der Traufe,
 *                  v von der Traufe zum First. Hier und nur hier wird belegt.
 *
 * Kapitel E der Spec: Wer im Grundriss belegt, legt zu wenige Module aufs Dach.
 */
export const gradInBogen = (grad) => (grad * Math.PI) / 180;
export const bogenInGrad = (bogen) => (bogen * 180) / Math.PI;
/** Auf 0 <= x < 360 bringen. */
export function normiereGrad(grad) {
    const rest = grad % 360;
    // Das + 0 macht aus -0 eine 0. Sonst steht bei einer Nordausrichtung "-0 Grad".
    return rest < 0 ? rest + 360 : rest + 0;
}
const HIMMELSRICHTUNGEN = [
    'Nord',
    'Nordost',
    'Ost',
    // Steht am Bildschirm und im Ausdruck — also mit Umlaut.
    'Südost',
    'Süd',
    'Südwest',
    'West',
    'Nordwest',
];
/** Azimut als Klartext, fuer die Anzeige neben der Gradzahl (PV-D10). */
export function himmelsrichtung(azimutGrad) {
    const sektor = Math.round(normiereGrad(azimutGrad) / 45) % 8;
    return HIMMELSRICHTUNGEN[sektor];
}
//# sourceMappingURL=typen.js.map